import { useAccordionGroupContext } from '../AccordionGroup/Context';

const useAccordion = () => {
  useAccordionGroupContext();
};

export default useAccordion;
